import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const ShapePolygonIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="shapePolygon" ref={ref} {...props}>
      <path d="M16.73,18.89H3a.75.75,0,0,1-.61-.32.76.76,0,0,1-.09-.7L5,10.76a.76.76,0,0,1,.7-.49h6l2.6-6a.74.74,0,0,1,.69-.45H22a.74.74,0,0,1,.7,1L17.43,18.41A.76.76,0,0,1,16.73,18.89ZM4.07,17.39H16.21L20.9,5.32H15.41l-2.6,6a.74.74,0,0,1-.69.45H6.18Z" />
    </Icon>
  ),
) as IconWithRender;

ShapePolygonIcon.displayName = 'ShapePolygonIcon';
ShapePolygonIcon.renderIcon = (props) => <ShapePolygonIcon {...props} />;
export default ShapePolygonIcon;
